/*========================================================================
 * $Id: grouped_collection.js 89578 2016-03-29 15:45:10Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 
define([
  "backbone",
  "utils/events",
  "underscore"
], function(
  Backbone,
  Events,
  _
) {

  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  return Backbone.Collection.extend({

    initialize: function (models, options) {
      this.delegate = options.delegate;
      this.groupingPath = options.groupingPath;
      this.compareFunctions = options.compareFunctions;

      this.listenTo(this.delegate, "add remove change", this.updateCollection);
      if (this.delegate.length) this.updateCollection();
    },

    reset: function (options) {

    },

    updateCollection: function(action) {
      var groupingPath = this.groupingPath,
          that = this;

      var collection = that.delegate;

      collection.each(function (model) {
        var groupPath = _.map(groupingPath, function(path) { return model.get(path) });
        var parent = _.reduce(groupPath, function (parent, groupId) {
          if (_.isUndefined(groupId) || _.isUndefined(parent)) return;
          var group = parent.get(groupId);
          if (!group) {
            parent.add({
              id: groupId,
              name: groupId,
              children: new Backbone.Collection()
            })
            group = parent.get(groupId)
          }
          return group.get("children");
        }, that);

        if (parent) parent.add(model);
      });

    }

  });

});
